import CryptoJS from 'crypto-js';

export const decryptPassword = (encryptedPassword, secret) => {
  try {
    if (!encryptedPassword || !secret) {
      return encryptedPassword || '';
    }

    const raw = CryptoJS.enc.Base64.parse(encryptedPassword);
    const iv = CryptoJS.lib.WordArray.create(raw.words.slice(0, 4)); // 16 bytes = 4 words
    const ciphertext = CryptoJS.lib.WordArray.create(raw.words.slice(4));

    const key = CryptoJS.SHA256(secret); // 256-bit key from passphrase

    const decrypted = CryptoJS.AES.decrypt({ ciphertext }, key, { iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Password decryption failed:', error);
    return encryptedPassword || ''; // Return original if decryption fails
  }
};
